import { FC } from "react";

import "./InformPanel.scss";
import { ProductInfo } from "../../../models/models";

const ActualInformPanel: FC<ProductInfo> = ({
    productName = "",
    totalLicenses = 0,
    soldLicenses = 0,
    expiredLicenses = 0,
    gracePeriodLicenses = 0,
    unsoldLicenses = 0,
    activatedLicenses = 0,
}) => {
    return (
        <div className="inform_panel__row">
            <div className="row__item">
                <div className="row__label">All Licenses:</div>
                <div className="row__data">{totalLicenses}</div>
            </div>

            <div className="row__item">
                <div className="row__label">Sold Licenses:</div>
                <div className="row__data">{soldLicenses}</div>
            </div>

            <div className="row__item">
                <div className="row__label">Unsold Licenses:</div>
                <div className="row__data">{unsoldLicenses}</div>
            </div>

            <div className="row__item color_yellow">
                <div className="row__label">Expired Licenses:</div>
                <div className="row__data">{expiredLicenses}</div>
            </div>

            <div className="row__item  color_purple">
                <div className="row__label">Grace period Licenses:</div>
                <div className="row__data">{gracePeriodLicenses}</div>
            </div>

            <div className="row__item color_green">
                <div className="row__label">Activated Licenses:</div>
                <div className="row__data">{activatedLicenses}</div>
            </div>
        </div>
    );
};

export default ActualInformPanel;
